import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";
import P2pListing from "./P2pv2";
import CreateListing from "./P2pv2Create";
import EditListing from "./P2pv2Edit";
import BuySellListing from "./P2pBuySellListing";
import SellToBuyListing from "./P2pSellToBuyListing";
import Trades from "./Trades";

const P2p = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={P2pListing} />
      <ProtectedRoute path={`${path}/trades`} component={Trades} />
      <ProtectedRoute path={`${path}/create`} component={CreateListing} />
      <ProtectedRoute path={`${path}/:id/edit`} component={EditListing} />
      <ProtectedRoute path={`${path}/:id/buy`} component={BuySellListing} />
      <ProtectedRoute path={`${path}/:id/sell`} component={SellToBuyListing} />
    </Switch>
  );
};

export default P2p;
